<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      flat
    >
      <div class="d-flex align-center">
        <a href="/">
          <v-img
            alt="さくさくレセプト.com会員サイト"
            class="shrink mr-2"
            contain
            src="/files/sakusakurogo1.jpg"
            transition="scale-transition"
            style="max-width: 260px;"
          />
        </a>

      </div>

      <v-spacer></v-spacer>

      <v-btn
        v-if="showHomeIcon"
        icon
        color="grey darken-2"
        @click="$router.push('/home')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <!--
      <v-menu v-if="$store.state.loggedIn" bottom left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="grey" v-bind="attrs" v-on="on" class="mr-1">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item link @click="$router.push('/account').catch(() => {})">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>アカウント</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item link @click="$router.push('/request').catch(() => {})">
            <v-list-item-icon>
              <v-icon>mdi-check</v-icon>
            </v-list-item-icon>
            <v-list-item-title>申し込み</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      -->
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <v-footer color="white" padless class="grey--text text--darken-3 sakusaku-footer">
      <v-container class="ma-0 mt-5 pa-0">
        <v-divider />
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="auto" class="px-5"><a href="/">ホーム</a></v-col>
          <v-divider vertical class="d-none d-sm-flex" />
          <v-col cols="12" md="auto" class="px-5"><a href="/#price">サービスと料金</a></v-col>
          <v-divider vertical class="d-none d-sm-flex" />
          <v-col cols="12" md="auto" class="px-5"><a href="/#flow">申請の流れ</a></v-col>
          <v-divider vertical class="d-none d-sm-flex" />
          <v-col cols="12" md="auto" class="px-5"><a href="/termsofuse/">利用規約</a></v-col>
          <v-divider vertical class="d-none d-sm-flex" />
          <v-col cols="12" md="auto" class="px-5"><a href="/privacy/">プライバシー</a></v-col>
          <v-divider vertical class="d-none d-sm-flex" />
          <v-col cols="12" md="auto" class="px-5"><a href="/form/contact/">お問い合わせ</a></v-col>
        </v-row>
        <v-divider />
      </v-container>
      <v-row class="ma-0 pa-5">
        <v-col cols="12" class="ma-0 pa-0"><h4 class="mb-3">株式会社メディブレーン</h4></v-col>
        <v-col cols="12" class="ma-0 pa-0">〒540-0025</v-col>
        <v-col cols="12" class="ma-0 pa-0">大阪市中央区徳井町二丁目4番14号</v-col>
        <v-col cols="12" class="ma-0 pa-0">宇野ビルディング8階</v-col>
        <v-col cols="12" class="ma-0 pa-0">TEL:06-6946-1128</v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
  computed: {
    showHomeIcon() {
      const reRequestPath = /^\/request/;
      if (reRequestPath.test(this.$route.path)) {
        return true;
      }
      if (this.$route.path === '/registration') {
        return true;
      }
      if (this.$route.path === '/unregistration') {
        return true;
      }
      if (this.$route.path === '/account') {
        return true;
      }
      return false;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
        .then(() => {
          this.$store.commit('setAfterLoginPath', '/request');
          this.$router.push('/');
        });
    }
  }
};
</script>

<style>
.sakusaku-footer a {
  overflow: hidden !important;
  color: #666 !important;
  text-decoration: none !important;
  font-size: 0.875rem !important;
}
.sakusaku-footer a:hover, .sakusaku-footer a:active {
  text-decoration: underline !important;
}
</style>
